import { useEffect } from "react";
import { ArrowLeft, Mic } from "lucide-react";

export const TIMSCRIBE_ENABLED = true; // flip to true to publish /timscribe + links

export const TIMSCRIBE = {
    title: "TimScribe",
    stripe: "https://buy.stripe.com/6oU6oG2Us1KYfHx954grS00",
    download: "/downloads/TimScribe-Windows-x64.zip",
    donation: "$5 AUD",
    donationNote: "optional · one-time · keeps the lab running",
};

export function useTsMeta(title, path) {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = title;
        const canonical = document.querySelector('link[rel="canonical"]');
        const prev = canonical?.getAttribute("href");
        canonical?.setAttribute("href", `https://timbotic.com${path}`);
        return () => {
            document.title = "TIMBOTIC | Inventions, Robotics & Experimental Projects";
            if (prev) canonical?.setAttribute("href", prev);
        };
    }, [title, path]);
}

export function TsHeader() {
    return (
        <header className="sticky top-0 z-50 backdrop-blur-md bg-[#f2f4f6]/90 border-b border-subtle" data-testid="timscribe-header">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <a href="/timscribe" className="flex items-center gap-3" data-testid="timscribe-logo">
                    <span className="h-7 w-7 rounded bg-cyan-100 border border-cyan-500/30 flex items-center justify-center">
                        <Mic className="h-3.5 w-3.5 text-cyan-700" />
                    </span>
                    <span className="font-mono text-sm tracking-widest font-bold text-cyan-700">
                        TIMSCRIBE<span className="text-cyan-600/60">//DICTATION</span>
                    </span>
                </a>
                <nav className="flex items-center gap-5 font-mono text-[11px] tracking-widest text-slate-500">
                    <a href="/timscribe/system-requirements" className="hidden sm:inline hover:text-cyan-700 transition-colors" data-testid="ts-nav-requirements">
                        REQUIREMENTS
                    </a>
                    <a href="/" className="inline-flex items-center gap-1.5 hover:text-cyan-700 transition-colors" data-testid="ts-nav-lab">
                        <ArrowLeft className="h-3 w-3" /> THE LAB
                    </a>
                    <a
                        href={TIMSCRIBE.download}
                        download
                        data-testid="ts-header-download"
                        className="inline-flex items-center rounded bg-cyan-500 text-slate-900 font-bold px-4 py-2 hover:bg-cyan-400 transition-colors"
                    >
                        DOWNLOAD · FREE
                    </a>
                </nav>
            </div>
        </header>
    );
}

export function TsFooter() {
    return (
        <footer className="bg-[#e2e8f0] border-t border-subtle py-10" data-testid="timscribe-footer">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 font-mono text-[11px] tracking-widest uppercase text-slate-500">
                <span>&copy; 2026 Timbotic · TimScribe</span>
                <nav className="flex flex-wrap gap-5">
                    <a href="/timscribe" className="hover:text-cyan-700 transition-colors">Overview</a>
                    <a href="/timscribe/system-requirements" className="hover:text-cyan-700 transition-colors">Getting started</a>
                    <a href="/" className="hover:text-cyan-700 transition-colors">timbotic.com</a>
                </nav>
            </div>
        </footer>
    );
}
